import { render, staticRenderFns } from "./caseinfo.vue?vue&type=template&id=2d8f00fc&scoped=true&"
import script from "./caseinfo.vue?vue&type=script&lang=js&"
export * from "./caseinfo.vue?vue&type=script&lang=js&"
import style0 from "./caseinfo.vue?vue&type=style&index=0&id=2d8f00fc&prod&lang=less&scoped=true&"
import style1 from "./caseinfo.vue?vue&type=style&index=1&id=2d8f00fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f00fc",
  null
  
)

export default component.exports